import { NavLink } from 'react-router-dom';
import { BookOpen, Home, NotebookPen, Repeat, User } from 'lucide-react';
import { BOTTOM_NAV_ITEMS, ROUTES } from '@/app/routes';
import { cn } from '@/lib/cn';

const ICONS = {
  home: Home,
  book: BookOpen,
  notebook: NotebookPen,
  repeat: Repeat,
  user: User,
} as const;

/**
 * 移动端底部导航（桌面端隐藏）。
 * 固定在安全区之上，并把每个入口做成 ≥44px 的点击区域，符合移动端可达性要求。
 */
export function BottomNav() {
  return (
    <nav
      aria-label="底部导航"
      className="fixed inset-x-0 bottom-0 z-40 border-t bg-background/95 pb-[env(safe-area-inset-bottom)] backdrop-blur md:hidden"
    >
      <ul className="mx-auto flex max-w-md items-stretch">
        {BOTTOM_NAV_ITEMS.map((item) => {
          const Icon = ICONS[item.icon];
          return (
            <li key={item.to} className="flex-1">
              <NavLink
                to={item.to}
                end={item.to === ROUTES.home}
                className={({ isActive }) =>
                  cn(
                    'flex min-h-14 flex-col items-center justify-center gap-0.5 text-[11px]',
                    isActive ? 'text-primary' : 'text-muted-foreground',
                  )
                }
              >
                <Icon aria-hidden className="size-5" />
                <span>{item.label}</span>
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
